<ng-container *ngIf="isSupported">
    <ms-share-my-bet [placedBetInfo]="placedBetInfo" [expandable]="true"></ms-share-my-bet>
    <ms-share-my-bet-copy [betslipId]="slip.betNumber" [location]="trackingInformation" [withHeader]="false"></ms-share-my-bet-copy>
</ng-container>
